module.exports = __webpack_public_path__ + "static/media/ha1.60df4b9f.gif";